var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 22,
    fill: "rgba(0, 0, 0, 0.38)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    width: 12,
    height: 22,
    fill: "rgba(0, 0, 0, 0.38)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarket);
export default __webpack_public_path__ + "static/media/market.c95208098718fe359b2fb61c2bbfe31f.svg";
export { ForwardRef as ReactComponent };